var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAngleBarLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M56.666 20c10.256 0 18.71 7.72 19.865 17.668L76.666 40v200c0 11.046-8.955 20-20 20-10.257 0-18.71-7.72-19.866-17.668L36.666 240V40c0-11.046 8.954-20 20-20m180.81 5.858c7.21 7.21 7.765 18.554 1.664 26.4l-1.663 1.884L151.626 140l85.85 85.858c7.21 7.21 7.765 18.554 1.664 26.4l-1.663 1.884c-7.21 7.21-18.555 7.764-26.4 1.664l-1.885-1.664-99.999-100c-7.21-7.21-7.764-18.554-1.663-26.4l1.663-1.884 100-100c7.81-7.81 20.473-7.81 28.284 0"
})));
export default SvgAngleBarLeft;